// status ids follow technical/claim-tracker/ (Open = 1)
export const qmeStatusOptions = [
  { id: 1, label: 'Open', className: 'initiated' },
  { id: 2, label: 'WIP', className: 'launched' },
  { id: 3, label: 'On-Hold', className: 'draft' },
  { id: 4, label: 'Closed', className: 'completed' },
];
export const qmeTypeOptions = [
  { value: 'airframe', label: 'Airframe' },
  { value: 'engine', label: 'Engine' },
  { value: 'landing_gear', label: 'Landing Gear' },
  { value: 'apu', label: 'APU' },
];
export const qmeProgressOptions = [25, 50, 75, 100];
export const landingGearPositions = ['LMLG', 'RMLG', 'NLG'];

export const qmeTrackerHd = [
  { id: 'project_number', label: 'Project / Claim Reference', sortOption: true, sticky: true, width: '220px' },
  { id: 'sysco_claim_number', label: 'SYSCO Claim Number', sortOption: true, width: '170px' },
  { id: 'msn', label: 'MSN', sortOption: true, width: '240px' },
  { label: 'Component S/N(s)', sortOption: false, width: '420px' },
  { id: 'mro_facility', label: 'MRO Facility', sortOption: true, width: '140px' },
  { id: 'lessee', label: 'Lessee', sortOption: true, width: '140px' },
  { id: 'qme_type', label: 'QME Type', sortOption: true, width: '180px' },
  { id: 'workscope', label: 'Workscope / Event', sortOption: true, width: '180px' },
  { label: 'Assigned To', sortOption: false, width: '360px' },
  { id: 'start_date', label: 'Start Date', sortOption: true, width: '120px' },
  { id: 'target_date', label: 'Target Date', sortOption: true, width: '120px' },
  { id: 'status', label: 'Status', sortOption: true, width: '110px' },
  { id: 'progress', label: 'Progress', sortOption: true, width: '140px' },
  { id: 'last_updated', label: 'Last Updated', sortOption: true, width: '170px' },
  { label: 'Next Action', sortOption: false, width: '180px' },
  { label: 'Vendor Remarks', sortOption: false, width: '180px' },
  { label: 'CSL Remarks', sortOption: false, width: '180px' },
  { label: 'Action(s)', sortOption: false, actionCell: true, width: '60px' },
];

export const qmeFilterOps = {
  'search': {
    'inputType': 'text',
    'title': 'Search'
  },
  'status': {
    'inputType': 'dropdown',
    'title': 'Status',
    'options': qmeStatusOptions,
    'labelKey': 'label',
    'valueKey': 'id',
    'multiple': true
  },
  'qme_type': {
    'inputType': 'dropdown',
    'title': 'QME Type',
    'options': qmeTypeOptions,
    'labelKey': 'label',
    'valueKey': 'value',
    'multiple': true
  },
  'lessee': {
    'inputType': 'dropdown',
    'title': 'Lessee',
    'options': [],
    'labelKey': 'name',
    'valueKey': 'id',
    'multiple': true
  },
};
